/**
 * Kind of this feature was introduced in redux-from@7.4.0 called "FormName"
 * @see https://github.com/redux-form/redux-form/releases/tag/v7.4.0
 */
import PropTypes from 'prop-types';
import { compose, getContext, withProps, mapProps } from 'recompose';
import omit from 'lodash/omit';
import pick from 'lodash/pick';

export const withFormName = compose(
  getContext({
    _reduxForm: PropTypes.object,
  }),
  withProps(({ _reduxForm }) => pick(_reduxForm, ['form', 'sectionPrefix'])),
  mapProps(props => omit(props, ['_reduxForm']))
);

export default withFormName;
